var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775",
    transform: "translate(-1691 -1864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "home_FILL0_wght400_GRAD0_opsz48",
    d: "M161.687,234.563h4.219v-7.031h6.188v7.031h4.219V223.594L169,218.109l-7.313,5.484ZM160,236.25v-13.5l9-6.75,9,6.75v13.5h-7.594v-7.031h-2.812v7.031ZM169,226.322Z",
    transform: "translate(1534 1650)",
    fill: "#918f90"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 24,
    height: 24,
    transform: "translate(1691 1864)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b22def07412e83db62c8207961566127.svg";
export { ForwardRef as ReactComponent };